module.exports = __webpack_public_path__ + "static/img/10.fb37998.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/10.jpg
// module id = R2vR
// module chunks = 0